<template>
  <span id="print-invoice">
    <el-tooltip v-if="this.showType == 'Button'" class="item" effect="dark" :content="$t('invoices.print')" placement="top-start">
      <i class="el-icon-printer icon-action" @click="handlePrint" />
    </el-tooltip>
    <a v-if="this.showType == 'Link'" @click="handlePrint" class="text-link">{{ this.linkText }}</a>
    <el-dialog
      width="25%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('invoices.print')"
      class="dialog-with-cols"
    >
      <el-row>
        <el-col>
          <el-button plain icon="el-icon-document" @click="printInvoice">{{ $t('invoices.flower.flowerInvoice') }}</el-button>
        </el-col>
      </el-row>
      <el-row v-if="$can(permissions.BILLING.PRICE_PER_BOX)">
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="printPricePerBox">{{ $t('invoices.flower.pricePerBox') }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import { Loading } from 'element-ui';
import constants from '@/utils/constants';

export default {
  name: 'PrintInvoice',
  props: {
    id: {
      type: Number,
      default: null
    },
    invoiceType: {
      type: Number,
      required: true
    },
    // 'Link' or 'Button'
    showType: {
      type: String,
      default: null
    },
    linkText: {
      type: String,
      default: null
    }
  },
  computed: {
    flowerInvoiceType() {
      return constants.INVOICE.TYPES[1].value;
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    async handlePrint() {
      if (this.invoiceType === this.flowerInvoiceType) {
        this.dialogVisible = true;
      } else {
        await this.printInvoice();
      }
    },
    async printInvoice() {
      const loading = Loading.service(constants.LOADING.PRINT_INVOICE_CONFIG);
      await this.$store.dispatch('invoices/printInvoice', this.id);
      loading.close();
      this.dialogVisible = false;
    },
    async printPricePerBox() {
      const loading = Loading.service(constants.LOADING.PRINT_PRICE_PER_BOX_CONFIG);
      await this.$store.dispatch('invoices/printPricePerBox', this.id);
      loading.close();
      this.dialogVisible = false;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#print-invoice {
  .el-button {
    margin-bottom: 10px;
    width: 100%;
  }
  .text-link {
    text-decoration: underline;
    color: #59AFE1;
  }
}
</style>
